module.exports = __webpack_public_path__ + "static/media/logoBAB.dbcdd8df.png";